import React from "react";

const Header = () => {
  return (
    <div className="row bg-primary text-center">
      <div className="col sm-12 md-8 ">
        <h2 className="text-white">Notice Finder</h2>
      </div>
    </div>
  );
};

export default Header;
